export const environment = {
  production: true,
  name: 'Dev',
  apiUrl: 'https://jobs-dev.chapps.com/'
};
